import { CommentEditor } from "components/Comments/CommentEditor";
import { CommentFeedItem } from "components/Comments/CommentFeedItem";
import ProgressIndicatorContainer from "components/ProgressIndicatorContainer";
import React from "react";
import { IComment, ICommentContent } from "interfaces/comment";
import Stack from "@mui/material/Stack";

export interface CommentFeedProps {
  loading: boolean;
  comments: IComment[];
  addComment: (content: ICommentContent) => Promise<IComment>;
  updateComment: (
    commentId: number,
    content: ICommentContent
  ) => Promise<IComment>;
  deleteComment: (commentId: number) => Promise<void>;
}

export const CommentFeed = ({
  loading,
  comments,
  addComment,
  updateComment,
  deleteComment
}: CommentFeedProps): JSX.Element => {
  // This is a list of rendered comments and a comment add form

  return (
    <ProgressIndicatorContainer loading={loading} error={false}>
      <Stack gap="12px">
        <CommentEditor
          onSubmit={(content: ICommentContent) => addComment(content)}
        />
        {comments.map((comment, index) => (
          <CommentFeedItem
            key={index}
            comment={comment}
            deleteComment={async () => await deleteComment(comment.id)}
            updateComment={async content =>
              await updateComment(comment.id, content)
            }
          />
        ))}
      </Stack>
    </ProgressIndicatorContainer>
  );
};
